/* Thor ruling 2026-10-23 (issue 2333): TerritorySettings stacks its zone rows 40px apart, so the remove mark keeps the 44px
   width and takes the 40px row pitch as its height. Two 44px targets overlapped by 4px there, and a click near a row edge
   could remove the next zone. A height-only exception to the 44px rule. */
export const TERRITORY_REMOVE_HIT_HEIGHT = 40;

/* The chevron toggle of the follow-up row (Today, Quick triage) sits 4px from the edge of its swipe slider. A 44px wide target
   reached 3px past that edge into the Snooze cell that a swipe reveals, so a tap there opened the menu and did not snooze
   (browser tap probe, issue 2333). The toggle keeps the 44px height and takes its 30px box plus the 4px on each side as its
   width. The target stays centered because the toggle turns 180deg while its menu is open. */
export const FOLLOW_UP_TOGGLE_HIT_WIDTH = 38;
